import { useState } from "react";
import ProductsBtn from "../../../components/sub/ProductsBtn";
import SubTitle from "../../../components/sub/SubTitle";
import Swal from "sweetalert2";
import axios from "axios";

const ProductsLineUp = () => {
  const productList = [
    {
      src: "/images/product1.webp",
      title: "H4 제품사진",
    },
    {
      src: "/images/product2.webp",
      title: "HBSC32 제품사진",
    },
    {
      src: "/images/product3.webp",
      title: "KH10 제품사진",
    },
    {
      src: "/images/product4.webp",
      title: "KH20 제품사진",
    },
    {
      src: "/images/product5.webp",
      title: "KH40-PRO 제품사진",
    },
  ];

  const lineupList = [
    {
      src: "/images/product6.webp",
      title: "곰팡이 제거",
      sub: ["H1", "KH10"],
    },
    {
      src: "/images/product7.webp",
      title: "기름때",
      sub: ["H2", "H3", "KH20", "KH200"],
    },
    {
      src: "/images/product8.webp",
      title: "각종 녹, 스케일 제거",
      sub: [
        "H4(녹제거)",
        "KH40(물때,백화제거)",
        "KH40 PRO(물때,백화 녹제거)",
        "KH40-C(동ᆞ녹제거)",
        "KH40-SR(스텐탈청제)",
        "KH40-NR(중성녹제거)",
        "HBSC-16,32(스케일제거)",
        "KH400, KH400-Plus (석재녹, 황변제거)",
      ],
    },
    {
      src: "/images/product9.webp",
      title: "기타",
      sub: [
        "HRX1(윤활방청제)",
        "KH 마스터(코팅제)",
        "Metal Ware(금속보호제)",
        "Stone Ware(석재보호제)",
      ],
    },
  ];

  const [name2, setName2] = useState("");
  const [phone2, setPhone2] = useState("");
  const [product, setProduct] = useState("");
  const [loading, setLoading] = useState(false);

  const handlerPostContact = async () => {
    if (!name2 || !phone2 || !product) {
      Swal.fire({
        title: "이름, 연락처, 제품을 모두 입력해주세요.",
        icon: "error",
      });
      return false;
    }

    if (phone2.length !== 11 || !phone2.includes("010")) {
      alert("010을 포함한 연락처를 모두 입력해주세요.");
      return false;
    }

    if (!window.confirm("문의 접수를 위한 개인정보 수집에 동의하시나요?")) {
      return false;
    }

    setLoading(true);

    await axios
      .post("/api/contact/product", {
        name: name2,
        phone: phone2,
        type: product,
        path: sessionStorage.getItem("path"),
      })
      .then((res) => {
        if (res.data.code === "0000") {
          Swal.fire({
            title: "문의 완료!",
            text: "문의 등록이 완료되었습니다.",
            icon: "success",
          }).then(() => (window.location.href = "/transform"));
        }
      })
      .catch((e) => {
        setLoading(false);
        Swal.fire({
          title: e,
          icon: "error",
        }).then(() => (window.location.href = "/"));
      });
  };

  return (
    <>
      <SubTitle
        src={"/images/subTitle4.webp"}
        title={"제품소개"}
        eng={"Introduction of item"}
      />
      <ProductsBtn id={1} />
      <div className="relative w-full h-full py-14 lg:py-28 xl:py-36 px-[calc((100%-var(--container))/2)]">
        <div
          id="title"
          className="relative w-full h-fit text-center mb-10 xl:mb-14"
        >
          <h3 className="text-center font-normal">
            카이노스 Bio 케미칼의 제품안내
          </h3>
          <div className=" relative w-fit h-fit border border-primary px-10 xl:px-20 mx-auto mt-5 xl:mt-8 py-1 text-primary">
            <p>18L제품사진</p>
          </div>
        </div>
        <div className=" relative w-full h-full grid xl:grid-cols-5 gap-5 lg:gap-6 text-center">
          {productList.map((v, i) => (
            <div
              key={i}
              data-aos="fade-up"
              className="border border-light relative w-full h-full overflow-hidden"
            >
              <div className="relative w-full h-fit py-2 bg-light z-10">
                <p>{v.title}</p>
              </div>
              <div className="">
                <img
                  className="hover:scale-125 transition-transform duration-200 object-contain w-auto h-full max-h-72 lg:max-h-none mx-auto"
                  src={v.src}
                  alt={v.title}
                />
              </div>
            </div>
          ))}
        </div>
        <div className="relative w-full h-full ">
          <h3 className="text-center font-normal my-5 lg:my-10 xl:text-4xl">
            구매희망시 아래 정보를 입력해주세요
          </h3>
          <div className="relative grid lg:grid-cols-4 gap-5 w-full h-full max-w-screen-xl mx-auto lg:rounded-full px-10 py-2 bg-gray-50 border">
            <div className="relative w-full h-full lg:flex items-center">
              <label htmlFor="name2" className="lg:text-xl lg:w-28">
                이름&nbsp;<span className="text-[var(--red-color)]">*</span>
              </label>
              <input
                type="text"
                placeholder="이름을 입력해주세요"
                value={name2}
                id="name2"
                className="!border-lightGray"
                onChange={(e) => setName2(e.target.value)}
              />
            </div>
            <div className="relative w-full h-full lg:flex items-center">
              <label htmlFor="phone2" className="lg:text-xl lg:w-28">
                연락처&nbsp;<span className="text-[var(--red-color)]">*</span>
              </label>
              <input
                type="text"
                placeholder="연락처를 입력해주세요"
                value={phone2}
                id="phone2"
                className="!border-lightGray"
                onChange={(e) =>
                  setPhone2(
                    e.target.value
                      .replace(/[^0-9.]/g, "")
                      .replace(/(\..*)\./g, "$1"),
                  )
                }
              />
            </div>
            <div className="relative w-full h-full lg:flex items-center">
              <label htmlFor="product" className="lg:text-xl lg:w-28">
                제품&nbsp;<span className="text-[var(--red-color)]">*</span>
              </label>
              <select
                name="product"
                id="product"
                className="!border-lightGray"
                onChange={(e) => setProduct(e.target.value)}
              >
                <option value="">제품명</option>
                {productList.map((v, i) => (
                  <option value={v.title}>
                    {v.title.replace("제품사진", "")}
                  </option>
                ))}
              </select>
            </div>
            <button
              type="button"
              className="relative w-full h-full bg-primary text-white grid items-center justify-center rounded-md"
            >
              <h4>전송하기</h4>
            </button>
          </div>
        </div>
        <div className="py-14 lg:py-28 xl:py-36">
          <div
            id="title"
            className="relative w-full h-fit text-center mb-10 xl:mb-14"
          >
            <h3 className="text-center font-normal">
              카이노스&nbsp;Bio 케미칼의
              <br className="block lg:hidden" /> 제품별&nbsp;Line-up
            </h3>
          </div>
          <div className=" relative w-full h-full grid grid-cols-2 xl:grid-cols-4 gap-5 lg:gap-6 text-center">
            {lineupList.map((v, i) => (
              <div
                key={i}
                data-aos="fade-up"
                className="border border-light relative w-full h-full overflow-hidden"
              >
                <div className="relative w-full h-fit bg-black text-white py-2 z-10">
                  <p>{v.title}</p>
                </div>
                <div className="relative w-full h-fit">
                  <img
                    className="hover:scale-125 transition-transform duration-200"
                    src={v.src}
                    alt={v.title}
                  />
                </div>
                <div className="relative w-full h-full lg:h-64 bg-light p-2 lg:p-5 text-left">
                  {v.sub.map((j, k) => (
                    <p className="text-sm leading-7" key={k}>
                      • {j}
                    </p>
                  ))}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </>
  );
};

export default ProductsLineUp;
